// Complete translation framework for LIBERADO - 100% coverage

export const translations = {
  es: {
    // Common
    appName: 'LIBERADO',
    login: 'Iniciar Sesión',
    signup: 'Registrarse',
    logout: 'Cerrar Sesión',
    save: 'Guardar',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    edit: 'Editar',
    submit: 'Enviar',
    back: 'Volver',
    close: 'Cerrar',
    welcome: 'Bienvenido',
    email: 'Email',
    password: 'Contraseña',
    name: 'Nombre',
    role: 'Rol',
    loading: 'Cargando...',
    error: 'Error',
    success: 'Éxito',
    
    // Navigation
    dashboard: 'Panel de Control',
    settings: 'Configuración',
    notifications: 'Notificaciones',
    home: 'Inicio',
    inicio: 'Inicio',
    about: 'Acerca de Nosotros',
    aboutUs: 'Acerca de Nosotros',
    
    // User types
    clinic: 'Clínica',
    technician: 'Técnico',
    admin: 'Administrador',
    
    // Landing page - UNLEASHED branding
    landingTitle: 'Conecta Clínicas Veterinarias con Talento Liberado',
    landingDescription: 'La plataforma premier para contratación de turnos veterinarios. Publica turnos, encuentra técnicos calificados y construye tu equipo de ensueño con confianza.',
    getStarted: 'Comenzar Hoy',
    iHaveAccount: 'Ya Tengo Cuenta',
    learnMore: 'Más Información',
    
    // About Us
    aboutTitle: 'Acerca de LIBERADO',
    aboutText1: 'Liberado fue creado por un equipo de técnicos veterinarios experimentados en los Estados Unidos, con experiencia en práctica general, medicina de emergencia y atención especializada avanzada. Después de años en la primera línea, vimos el mismo problema en todas partes: a pesar de ser esenciales para las operaciones hospitalarias, los técnicos veterinarios casi no tenían herramientas construidas específicamente para apoyar su flujo de trabajo, proteger su tiempo o elevar su profesión.',
    aboutText2: 'Liberado fue construido para cambiar eso.',
    aboutText3: 'Como el primer mercado de turnos veterinarios diseñado por técnicos veterinarios para Chile, Liberado combina experiencia clínica del mundo real con tecnología avanzada e innovación impulsada por IA. Nuestra plataforma utiliza automatización inteligente, programación inteligente y algoritmos de emparejamiento dinámico para ayudar a las clínicas a conectarse de manera confiable con talento calificado, al tiempo que brinda a los técnicos flexibilidad, transparencia y control sin precedentes sobre su trabajo.',
    aboutText4: 'El logo de la cadena rota simboliza exactamente lo que defendemos: liberación de sistemas de personal obsoletos, expectativas injustas y procesos opacos. En su lugar, Liberado introduce un nuevo modelo centrado en el empoderamiento, profesionalismo y respeto por las personas que mantienen la medicina veterinaria en movimiento.',
    aboutText5: 'Liberado es más que una plataforma de personal: es un movimiento impulsado por IA hacia un ecosistema veterinario más sostenible, equitativo y preparado para el futuro. Uno donde las clínicas prosperan, los técnicos son valorados y toda la profesión evoluciona junta.',
    
    // Subscriptions
    subscription: 'Suscripción',
    subscriptionPlan: 'Plan de Suscripción',
    standard: 'Estándar',
    pro: 'Pro',
    enterprise: 'Enterprise',
    postsUsed: 'Turnos publicados',
    postsLimit: 'Límite de turnos',
    upgradePlan: 'Actualizar Plan',
    currentPlan: 'Plan Actual',
    
    // Shifts
    shift: 'Turno',
    shifts: 'Turnos',
    postShift: 'Publicar Turno',
    activeShifts: 'Turnos Activos',
    availableShifts: 'Turnos Disponibles',
    shiftTemplates: 'Plantillas de Turnos',
    viewTemplates: 'Ver Plantillas',
    noActiveShifts: 'No hay turnos activos',
    noAvailableShifts: 'No hay turnos disponibles',
    shiftsWillAppear: 'Los turnos publicados aparecerán aquí',
    matchingShifts: 'Los turnos que coincidan con tu nivel ToS aparecerán aquí',
    inProgress: 'En progreso',
    newMessages: 'Mensajes nuevos',
    shiftDetails: 'Detalles del Turno',
    
    // ToS
    tosLevel: 'Nivel ToS',
    certifications: 'Certificaciones',
    viewCertifications: 'Ver Certificaciones',
    
    // Earnings
    earnings: 'Ganancias',
    thisMonth: 'Este mes',
    myShifts: 'Mis Turnos',
    confirmedShifts: 'Turnos confirmados',
    
    // Test Mode
    testMode: 'Modo de Prueba',
    testModeActive: 'Modo de Prueba Activo',
    testModeControls: 'Controles del Modo de Prueba',
    testModeInstructions: 'Usa estos controles para simular cambios de tiempo, roles y configuraciones.',
    timeTravel: 'Viaje en el Tiempo',
    currentTime: 'Tiempo Actual',
    changeRole: 'Cambiar Rol',
    changeSubscription: 'Cambiar Suscripción',
    changeToS: 'Cambiar ToS',
    resetTime: 'Restablecer Tiempo',
    
    // Admin
    totalUsers: 'Total Usuarios',
    usersRegistered: 'Usuarios registrados',
    totalEscrow: 'Escrow Total',
    inEscrow: 'En depósito',
    userManagement: 'Gestión de Usuarios',
    viewAllUsers: 'Ver Todos los Usuarios',
    manualOverrides: 'Overrides Manuales',
    systemLogs: 'Logs del Sistema',
    viewLogs: 'Ver Logs del Sistema',
    escrowLedger: 'Ledger de Escrow',
    system: 'Sistema',
    adminPanel: 'Panel de Administración',
    userList: 'Lista de Usuarios',
    noUsers: 'No hay usuarios registrados',
    userId: 'ID de Usuario',
    selectUser: 'Seleccionar Usuario',
    lockAccount: 'Bloquear Cuenta',
    unlockAccount: 'Desbloquear Cuenta',
    
    // Forms
    clinicAccount: 'Cuenta de Clínica',
    techAccount: 'Cuenta de Técnico',
    accountType: 'Tipo de cuenta',
    noAccount: '¿No tienes cuenta?',
    haveAccount: '¿Ya tienes cuenta?',
    yourName: 'Tu nombre',
    enterEmail: 'Ingresa tu email',
    enterPassword: 'Ingresa tu contraseña',
    enterName: 'Ingresa tu nombre',
    required: 'Requerido',
    
    // Messages
    saveTemplates: 'Guarda plantillas para publicar turnos más rápido',
    publishNewShift: 'Publica un nuevo turno para técnicos veterinarios',
    
    // Placeholders
    comingSoon: 'Próximamente',
    featureComingSoon: 'Función Próximamente',
    phase2Feature: 'Esta función se implementará en la Fase 2+',
    placeholder: 'Marcador de Posición',
    
    // Errors
    errorOccurred: 'Ocurrió un error',
    tryAgain: 'Intentar de nuevo',
    invalidCredentials: 'Credenciales inválidas',
    
    // Interest Form
    interestFormTitle: 'Registro de Interés',
    interestFormSubtitle: 'Regístrate para recibir una invitación cuando lancemos',
    fullName: 'Nombre Completo',
    enterFullName: 'Ingresa tu nombre completo',
    phoneWhatsapp: 'Teléfono o WhatsApp',
    regionComuna: 'Comuna / Región',
    enterRegion: 'Ingresa tu comuna o región',
    yourRole: 'Tu Rol',
    vetTechnician: 'Técnico Veterinario',
    vetTechnicianUncertified: 'Técnico Veterinario (no certificado)',
    vetClinic: 'Clínica Veterinaria',
    veterinarian: 'Veterinario',
    petSitter: 'Pet Sitter / Cuidador@',
    preferredLanguage: 'Idioma Preferido',
    optionalMessage: 'Mensaje Opcional',
    messagePlaceholder: 'Cuéntanos sobre tu interés...',
    wantLaunchInfo: 'Quiero recibir información sobre el lanzamiento',
    submitInterest: 'Enviar Registro',
    thankYou: '¡Gracias!',
    willContact: 'Te contactaremos cuando lancemos la plataforma',
    interestRegistration: 'Registro de Interés',
    registerForInvitation: 'Regístrate para recibir una invitación',
    availableSoonChile: 'Disponible pronto en Chile',
    sdgStatement: 'Alineado con los Objetivos de Desarrollo Sostenible de las Naciones Unidas (ODS 3, 8, 9 y 10)',
    platformInPreparation: 'La plataforma está en preparación. Regístrate para recibir una invitación.',
    registrationSoonAvailable: 'El registro estará disponible pronto para usuarios de Chile.',
    
    // Footer
    copyright: '© 2025 LIBERADO. AI Powered Staffing Platform Empowering the Veterinary Industry.',
    termsOfService: 'Términos de Servicio',
    privacyPolicy: 'Política de Privacidad',
    contactSupport: 'Contactar Soporte',
    marketplacePolicy: 'Política del Mercado',
    
    // Phone Validation Error
    invalidPhoneError: 'Por favor ingresa un número de teléfono chileno válido (+56 9 #### #### o 9#### ####)',
    
    // Thank You Page
    thankYouTitle: '¡Gracias!',
    thankYouMessage: 'Tu registro ha sido recibido. Te contactaremos cuando lancemos la plataforma.',
    backToHome: 'Volver al inicio',
    
    // Innovation & Roadmap
    innovationRoadmapTitle: 'Innovación & Roadmap',
    innovationRoadmapSubtitle: 'Nuestro plan de desarrollo y visión de futuro',
    roadmapDisclaimer: 'Liberado se encuentra actualmente en fase de prototipo y validación. No todas las funcionalidades descritas se encuentran implementadas en este momento.',
    
    // Current State (2025)
    roadmapCurrentTitle: 'Dónde estamos hoy',
    roadmapCurrentPoint1: 'Prototipo funcional en fase temprana',
    roadmapCurrentPoint2: 'Investigación de mercado en curso',
    roadmapCurrentPoint3: 'Exploración de posibles alianzas con clínicas en Chile',
    
    // Implementation Phase (2026-2027)
    roadmapImplementationTitle: 'Próximos 12–24 meses (2026–2027)',
    roadmapImplementationPoint1: 'Implementación gradual post-financiamiento',
    roadmapImplementationPoint2: 'Automatización + IA avanzada',
    roadmapImplementationPoint3: 'Expansión nacional Chile',
    
    // AI Innovation Line
    roadmapAITitle: 'Línea de tiempo IA',
    roadmapAIPoint1: 'Fase 1: Recomendación básica (actual)',
    roadmapAIPoint2: 'Fase 2: Matching predictivo',
    roadmapAIPoint3: 'Fase 3: Automatización + soporte',
    roadmapAIPoint4: 'Fase futura: Módulo LENNY (extensión no clínica)',
    
    // Impact in Chile
    roadmapImpactTitle: 'Impacto esperado en Chile',
    roadmapImpactPoint1: 'Reducción de carga operativa',
    roadmapImpactPoint2: 'Mejora en cobertura veterinaria',
    roadmapImpactPoint3: 'Formalización laboral técnica',
    
    // SDG Alignment
    roadmapSDGTitle: 'Alineación con Objetivos de Desarrollo Sostenible (ODS)',
    roadmapSDGIntro: 'Liberado contribuye directamente a:',
    roadmapSDG1Title: 'ODS 8 – Trabajo decente y crecimiento económico',
    roadmapSDG1Text: 'Expande oportunidades laborales dignas y flexibles para técnicos veterinarios, reduciendo subempleo y fortaleciendo clínicas.',
    roadmapSDG2Title: 'ODS 3 – Salud y bienestar',
    roadmapSDG2Text: 'Mejora la calidad y continuidad de la atención veterinaria mediante una asignación eficiente de personal calificado.',
    roadmapSDG3Title: 'ODS 9 – Industria, innovación e infraestructura',
    roadmapSDG3Text: 'Moderniza la infraestructura de vinculación laboral en salud veterinaria mediante herramientas digitales e inteligencia artificial.',
    roadmapSDG4Title: 'ODS 10 – Reducción de las desigualdades',
    roadmapSDG4Text: 'Amplía el acceso a oportunidades para técnicos en zonas rurales o subrepresentadas, disminuyendo brechas de empleo.',
    sdgFooterText: 'Proyecto alineado con los ODS 8, 3, 9 y 10 de Naciones Unidas.',
    
    // Privacy Policy
    privacyPolicyTitle: 'Política de Privacidad',
    privacyLastUpdated: 'Última actualización',
    privacyLastUpdatedDate: 'Enero 2025',
    
    privacySection1Title: '1. Datos que recopilamos',
    privacySection1Text: 'En Liberado, recopilamos la siguiente información cuando te registras o interactúas con nuestra plataforma:',
    privacySection1Item1: 'Nombre completo y correo electrónico',
    privacySection1Item2: 'Número de teléfono o WhatsApp',
    privacySection1Item3: 'Región o comuna de residencia',
    privacySection1Item4: 'Rol profesional (técnico, clínica, veterinario, etc.)',
    
    privacySection2Title: '2. Uso de la información',
    privacySection2Text: 'Utilizamos tus datos para los siguientes propósitos:',
    privacySection2Item1: 'Comunicarnos contigo sobre el lanzamiento de la plataforma',
    privacySection2Item2: 'Personalizar tu experiencia en Liberado',
    privacySection2Item3: 'Mejorar nuestros servicios y funcionalidades',
    privacySection2Item4: 'Cumplir con requisitos legales y regulatorios',
    
    privacySection3Title: '3. Almacenamiento de datos',
    privacySection3Text: 'Los datos pueden ser almacenados en Chile y/o Estados Unidos, utilizando servicios de alojamiento seguros y certificados. Implementamos medidas técnicas y organizativas para proteger tu información.',
    
    privacySection4Title: '4. Seguridad',
    privacySection4Text: 'Aplicamos estándares de seguridad de la industria para proteger tus datos personales contra acceso no autorizado, alteración, divulgación o destrucción. Sin embargo, ningún sistema es 100% seguro, por lo que te recomendamos tomar precauciones adicionales.',
    
    privacySection5Title: '5. Tus derechos',
    privacySection5Text: 'Como usuario, tienes derecho a:',
    privacySection5Item1: 'Acceder a tus datos personales',
    privacySection5Item2: 'Solicitar la corrección o eliminación de tu información',
    privacySection5Item3: 'Oponerte al procesamiento de tus datos',
    privacySection5Item4: 'Retirar tu consentimiento en cualquier momento',
    
    privacyContactTitle: 'Contacto para consultas de privacidad',
    privacyContactText: 'Si tienes preguntas sobre esta política, contáctanos en',
  },
  
  en: {
    // Common
    appName: 'LIBERADO',
    login: 'Log In',
    signup: 'Sign Up',
    logout: 'Log Out',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    submit: 'Submit',
    back: 'Back',
    close: 'Close',
    welcome: 'Welcome',
    email: 'Email',
    password: 'Password',
    name: 'Name',
    role: 'Role',
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    
    // Navigation
    dashboard: 'Dashboard',
    settings: 'Settings',
    notifications: 'Notifications',
    home: 'Home',
    inicio: 'Home',
    about: 'About Us',
    aboutUs: 'About Us',
    
    // User types
    clinic: 'Clinic',
    technician: 'Technician',
    admin: 'Administrator',
    
    // Landing page - UNLEASHED branding
    landingTitle: 'Connect Veterinary Clinics with Unleashed Talent',
    landingDescription: 'The premier platform for veterinary shift staffing. Post shifts, find skilled technicians, and build your dream team with confidence.',
    getStarted: 'Get Started Today',
    iHaveAccount: 'I Have an Account',
    learnMore: 'Learn More',
    
    // About Us
    aboutTitle: 'About LIBERADO',
    aboutText1: 'Liberado was created by a team of experienced veterinary technicians across the United States, with backgrounds spanning general practice, emergency medicine, and advanced specialty care. After years on the front lines, we saw the same problem everywhere: despite being essential to hospital operations, veterinary technicians had almost no tools built specifically to support their workflow, protect their time, or elevate their profession.',
    aboutText2: 'Liberado was built to change that.',
    aboutText3: 'As the first veterinary shift marketplace designed by veterinary technicians for Chile, Liberado combines real-world clinical experience with advanced technology and AI-driven innovation. Our platform uses intelligent automation, smart scheduling, and dynamic matching algorithms to help clinics reliably connect with skilled talent—while giving technicians unprecedented flexibility, transparency, and control over their work.',
    aboutText4: 'The broken-chain logo symbolizes exactly what we stand for: liberation from outdated staffing systems, unfair expectations, and opaque processes. In their place, Liberado introduces a new model centered on empowerment, professionalism, and respect for the people who keep veterinary medicine moving.',
    aboutText5: 'Liberado is more than a staffing platform—it is an AI-powered movement toward a more sustainable, equitable, and future-ready veterinary ecosystem. One where clinics thrive, technicians are valued, and the entire profession evolves together.',
    
    // Subscriptions
    subscription: 'Subscription',
    subscriptionPlan: 'Subscription Plan',
    standard: 'Standard',
    pro: 'Pro',
    enterprise: 'Enterprise',
    postsUsed: 'Shifts posted',
    postsLimit: 'Shift limit',
    upgradePlan: 'Upgrade Plan',
    currentPlan: 'Current Plan',
    
    // Shifts
    shift: 'Shift',
    shifts: 'Shifts',
    postShift: 'Post Shift',
    activeShifts: 'Active Shifts',
    availableShifts: 'Available Shifts',
    shiftTemplates: 'Shift Templates',
    viewTemplates: 'View Templates',
    noActiveShifts: 'No active shifts',
    noAvailableShifts: 'No available shifts',
    shiftsWillAppear: 'Posted shifts will appear here',
    matchingShifts: 'Shifts matching your ToS level will appear here',
    inProgress: 'In progress',
    newMessages: 'New messages',
    shiftDetails: 'Shift Details',
    
    // ToS
    tosLevel: 'ToS Level',
    certifications: 'Certifications',
    viewCertifications: 'View Certifications',
    
    // Earnings
    earnings: 'Earnings',
    thisMonth: 'This month',
    myShifts: 'My Shifts',
    confirmedShifts: 'Confirmed shifts',
    
    // Test Mode
    testMode: 'Test Mode',
    testModeActive: 'Test Mode Active',
    testModeControls: 'Test Mode Controls',
    testModeInstructions: 'Use these controls to simulate time changes, roles, and settings.',
    timeTravel: 'Time Travel',
    currentTime: 'Current Time',
    changeRole: 'Change Role',
    changeSubscription: 'Change Subscription',
    changeToS: 'Change ToS',
    resetTime: 'Reset Time',
    
    // Admin
    totalUsers: 'Total Users',
    usersRegistered: 'Registered users',
    totalEscrow: 'Total Escrow',
    inEscrow: 'In escrow',
    userManagement: 'User Management',
    viewAllUsers: 'View All Users',
    manualOverrides: 'Manual Overrides',
    systemLogs: 'System Logs',
    viewLogs: 'View System Logs',
    escrowLedger: 'Escrow Ledger',
    system: 'System',
    adminPanel: 'Administration Panel',
    userList: 'User List',
    noUsers: 'No users registered',
    userId: 'User ID',
    selectUser: 'Select User',
    lockAccount: 'Lock Account',
    unlockAccount: 'Unlock Account',
    
    // Forms
    clinicAccount: 'Clinic Account',
    techAccount: 'Technician Account',
    accountType: 'Account type',
    noAccount: "Don't have an account?",
    haveAccount: 'Already have an account?',
    yourName: 'Your name',
    enterEmail: 'Enter your email',
    enterPassword: 'Enter your password',
    enterName: 'Enter your name',
    required: 'Required',
    
    // Messages
    saveTemplates: 'Save templates to post shifts faster',
    publishNewShift: 'Publish a new shift for veterinary technicians',
    
    // Placeholders
    comingSoon: 'Coming Soon',
    featureComingSoon: 'Feature Coming Soon',
    phase2Feature: 'This feature will be implemented in Phase 2+',
    placeholder: 'Placeholder',
    
    // Errors
    errorOccurred: 'An error occurred',
    tryAgain: 'Try again',
    invalidCredentials: 'Invalid credentials',
    
    // Interest Form
    interestFormTitle: 'Interest Registration',
    interestFormSubtitle: 'Register to receive an invitation when we launch',
    fullName: 'Full Name',
    enterFullName: 'Enter your full name',
    phoneWhatsapp: 'Phone or WhatsApp',
    regionComuna: 'Region / City',
    enterRegion: 'Enter your region or city',
    yourRole: 'Your Role',
    vetTechnician: 'Veterinary Technician',
    vetTechnicianUncertified: 'Veterinary Technician (uncertified)',
    vetClinic: 'Veterinary Clinic',
    veterinarian: 'Veterinarian',
    petSitter: 'Pet Sitter / Caregiver',
    preferredLanguage: 'Preferred Language',
    optionalMessage: 'Optional Message',
    messagePlaceholder: 'Tell us about your interest...',
    wantLaunchInfo: 'I want to receive information about the launch',
    submitInterest: 'Submit Registration',
    thankYou: 'Thank You!',
    willContact: 'We will contact you when we launch the platform',
    interestRegistration: 'Interest Registration',
    registerForInvitation: 'Register to receive an invitation',
    availableSoonChile: 'Available soon in Chile',
    sdgStatement: 'Aligned with the UN Sustainable Development Goals (SDG 3, 8, 9 & 10)',
    platformInPreparation: 'The platform is in preparation. Register to receive an invitation.',
    registrationSoonAvailable: 'Registration will be available soon for users in Chile.',
    
    // Footer
    copyright: '© 2025 LIBERADO. AI Powered Staffing Platform Empowering the Veterinary Industry.',
    termsOfService: 'Terms of Service',
    privacyPolicy: 'Privacy Policy',
    contactSupport: 'Contact Support',
    marketplacePolicy: 'Marketplace Policy',
    
    // Phone Validation Error
    invalidPhoneError: 'Please enter a valid Chilean phone number (+56 9 #### #### or 9#### ####)',
    
    // Thank You Page
    thankYouTitle: 'Thank You!',
    thankYouMessage: 'Your registration has been received. We will contact you when we launch the platform.',
    backToHome: 'Back to Home',
    
    // Innovation & Roadmap
    innovationRoadmapTitle: 'Innovation & Roadmap',
    innovationRoadmapSubtitle: 'Our development plan and future vision',
    roadmapDisclaimer: 'Liberado is currently in the prototype and validation phase. Not all described functionalities are implemented at this time.',
    
    // Current State (2025)
    roadmapCurrentTitle: 'Where we are today',
    roadmapCurrentPoint1: 'Functional prototype in early stage',
    roadmapCurrentPoint2: 'Market research in progress',
    roadmapCurrentPoint3: 'Exploring partnerships with clinics in Chile',
    
    // Implementation Phase (2026-2027)
    roadmapImplementationTitle: 'Next 12–24 months (2026–2027)',
    roadmapImplementationPoint1: 'Gradual implementation post-funding',
    roadmapImplementationPoint2: 'Automation + advanced AI',
    roadmapImplementationPoint3: 'National expansion Chile',
    
    // AI Innovation Line
    roadmapAITitle: 'AI timeline',
    roadmapAIPoint1: 'Phase 1: Basic recommendation (current)',
    roadmapAIPoint2: 'Phase 2: Predictive matching',
    roadmapAIPoint3: 'Phase 3: Automation + support',
    roadmapAIPoint4: 'Future phase: LENNY module (non-clinical extension)',
    
    // Impact in Chile
    roadmapImpactTitle: 'Expected impact in Chile',
    roadmapImpactPoint1: 'Reduction in operational burden',
    roadmapImpactPoint2: 'Improved veterinary coverage',
    roadmapImpactPoint3: 'Technical labor formalization',
    
    // SDG Alignment
    roadmapSDGTitle: 'Alignment with Sustainable Development Goals (SDGs)',
    roadmapSDGIntro: 'Liberado directly contributes to:',
    roadmapSDG1Title: 'SDG 8 – Decent work and economic growth',
    roadmapSDG1Text: 'Expands decent and flexible job opportunities for veterinary technicians, reducing underemployment and strengthening clinics.',
    roadmapSDG2Title: 'SDG 3 – Health and well-being',
    roadmapSDG2Text: 'Improves the quality and continuity of veterinary care through efficient allocation of qualified personnel.',
    roadmapSDG3Title: 'SDG 9 – Industry, innovation and infrastructure',
    roadmapSDG3Text: 'Modernizes job linkage infrastructure in veterinary health through digital tools and artificial intelligence.',
    roadmapSDG4Title: 'SDG 10 – Reduced inequalities',
    roadmapSDG4Text: 'Expands access to opportunities for technicians in rural or underrepresented areas, reducing employment gaps.',
    sdgFooterText: 'Project aligned with UN SDGs 8, 3, 9 and 10.',
    
    // Privacy Policy
    privacyPolicyTitle: 'Privacy Policy',
    privacyLastUpdated: 'Last updated',
    privacyLastUpdatedDate: 'January 2025',
    
    privacySection1Title: '1. Data we collect',
    privacySection1Text: 'At Liberado, we collect the following information when you register or interact with our platform:',
    privacySection1Item1: 'Full name and email address',
    privacySection1Item2: 'Phone number or WhatsApp',
    privacySection1Item3: 'Region or commune of residence',
    privacySection1Item4: 'Professional role (technician, clinic, veterinarian, etc.)',
    
    privacySection2Title: '2. Use of information',
    privacySection2Text: 'We use your data for the following purposes:',
    privacySection2Item1: 'Communicate with you about the platform launch',
    privacySection2Item2: 'Personalize your experience on Liberado',
    privacySection2Item3: 'Improve our services and functionalities',
    privacySection2Item4: 'Comply with legal and regulatory requirements',
    
    privacySection3Title: '3. Data storage',
    privacySection3Text: 'Data may be stored in Chile and/or the United States, using secure and certified hosting services. We implement technical and organizational measures to protect your information.',
    
    privacySection4Title: '4. Security',
    privacySection4Text: 'We apply industry security standards to protect your personal data against unauthorized access, alteration, disclosure, or destruction. However, no system is 100% secure, so we recommend taking additional precautions.',
    
    privacySection5Title: '5. Your rights',
    privacySection5Text: 'As a user, you have the right to:',
    privacySection5Item1: 'Access your personal data',
    privacySection5Item2: 'Request correction or deletion of your information',
    privacySection5Item3: 'Object to the processing of your data',
    privacySection5Item4: 'Withdraw your consent at any time',
    
    privacyContactTitle: 'Contact for privacy inquiries',
    privacyContactText: 'If you have questions about this policy, contact us at',
  },
  
  pt: {
    // Common
    appName: 'LIBERADO',
    login: 'Entrar',
    signup: 'Cadastrar',
    logout: 'Sair',
    save: 'Salvar',
    cancel: 'Cancelar',
    delete: 'Excluir',
    edit: 'Editar',
    submit: 'Enviar',
    back: 'Voltar',
    close: 'Fechar',
    welcome: 'Bem-vindo',
    email: 'Email',
    password: 'Senha',
    name: 'Nome',
    role: 'Papel',
    loading: 'Carregando...',
    error: 'Erro',
    success: 'Sucesso',
    
    // Navigation
    dashboard: 'Painel',
    settings: 'Configurações',
    notifications: 'Notificações',
    home: 'Início',
    inicio: 'Início',
    about: 'Sobre Nós',
    aboutUs: 'Sobre Nós',
    
    // User types
    clinic: 'Clínica',
    technician: 'Técnico',
    admin: 'Administrador',
    
    // Landing page - UNLEASHED branding
    landingTitle: 'Conecte Clínicas Veterinárias com Talento Liberto',
    landingDescription: 'A plataforma premier para contratação de turnos veterinários. Publique turnos, encontre técnicos qualificados e construa sua equipe dos sonhos com confiança.',
    getStarted: 'Começar Hoje',
    iHaveAccount: 'Já Tenho uma Conta',
    learnMore: 'Saiba Mais',
    
    // About Us
    aboutTitle: 'Sobre LIBERADO',
    aboutText1: 'Liberado foi criado por uma equipe de técnicos veterinários experientes nos Estados Unidos, com experiência em prática geral, medicina de emergência e cuidados especializados avançados. Depois de anos na linha de frente, vimos o mesmo problema em todos os lugares: apesar de serem essenciais para as operações hospitalares, os técnicos veterinários quase não tinham ferramentas construídas especificamente para apoiar seu fluxo de trabalho, proteger seu tempo ou elevar sua profissão.',
    aboutText2: 'Liberado foi construído para mudar isso.',
    aboutText3: 'Como o primeiro mercado de turnos veterinários projetado por técnicos veterinários para o Chile, Liberado combina experiência clínica do mundo real com tecnologia avançada e inovação impulsionada por IA. Nossa plataforma usa automação inteligente, agendamento inteligente e algoritmos de correspondência dinâmica para ajudar as clínicas a se conectarem de forma confiável com talentos qualificados - ao mesmo tempo em que oferece aos técnicos flexibilidade, transparência e controle sem precedentes sobre seu trabalho.',
    aboutText4: 'O logotipo da corrente quebrada simboliza exatamente o que defendemos: liberação de sistemas de pessoal obsoletos, expectativas injustas e processos opacos. Em seu lugar, Liberado introduz um novo modelo centrado no empoderamento, profissionalismo e respeito pelas pessoas que mantêm a medicina veterinária em movimento.',
    aboutText5: 'Liberado é mais do que uma plataforma de pessoal - é um movimento impulsionado por IA em direção a um ecossistema veterinário mais sustentável, equitativo e preparado para o futuro. Um onde as clínicas prosperam, os técnicos são valorizados e toda a profissão evolui junta.',
    
    // Subscriptions
    subscription: 'Assinatura',
    subscriptionPlan: 'Plano de Assinatura',
    standard: 'Padrão',
    pro: 'Pro',
    enterprise: 'Enterprise',
    postsUsed: 'Turnos publicados',
    postsLimit: 'Limite de turnos',
    upgradePlan: 'Atualizar Plano',
    currentPlan: 'Plano Atual',
    
    // Shifts
    shift: 'Turno',
    shifts: 'Turnos',
    postShift: 'Publicar Turno',
    activeShifts: 'Turnos Ativos',
    availableShifts: 'Turnos Disponíveis',
    shiftTemplates: 'Modelos de Turnos',
    viewTemplates: 'Ver Modelos',
    noActiveShifts: 'Sem turnos ativos',
    noAvailableShifts: 'Sem turnos disponíveis',
    shiftsWillAppear: 'Os turnos publicados aparecerão aqui',
    matchingShifts: 'Os turnos que correspondem ao seu nível ToS aparecerão aqui',
    inProgress: 'Em andamento',
    newMessages: 'Novas mensagens',
    shiftDetails: 'Detalhes do Turno',
    
    // ToS
    tosLevel: 'Nível ToS',
    certifications: 'Certificações',
    viewCertifications: 'Ver Certificações',
    
    // Earnings
    earnings: 'Ganhos',
    thisMonth: 'Este mês',
    myShifts: 'Meus Turnos',
    confirmedShifts: 'Turnos confirmados',
    
    // Test Mode
    testMode: 'Modo de Teste',
    testModeActive: 'Modo de Teste Ativo',
    testModeControls: 'Controles do Modo de Teste',
    testModeInstructions: 'Use estes controles para simular mudanças de tempo, papéis e configurações.',
    timeTravel: 'Viagem no Tempo',
    currentTime: 'Tempo Atual',
    changeRole: 'Mudar Papel',
    changeSubscription: 'Mudar Assinatura',
    changeToS: 'Mudar ToS',
    resetTime: 'Redefinir Tempo',
    
    // Admin
    totalUsers: 'Total de Usuários',
    usersRegistered: 'Usuários registrados',
    totalEscrow: 'Escrow Total',
    inEscrow: 'Em depósito',
    userManagement: 'Gestão de Usuários',
    viewAllUsers: 'Ver Todos os Usuários',
    manualOverrides: 'Substituições Manuais',
    systemLogs: 'Logs do Sistema',
    viewLogs: 'Ver Logs do Sistema',
    escrowLedger: 'Registro de Escrow',
    system: 'Sistema',
    adminPanel: 'Painel de Administração',
    userList: 'Lista de Usuários',
    noUsers: 'Nenhum usuário registrado',
    userId: 'ID do Usuário',
    selectUser: 'Selecionar Usuário',
    lockAccount: 'Bloquear Conta',
    unlockAccount: 'Desbloquear Conta',
    
    // Forms
    clinicAccount: 'Conta de Clínica',
    techAccount: 'Conta de Técnico',
    accountType: 'Tipo de conta',
    noAccount: 'Não tem uma conta?',
    haveAccount: 'Já tem uma conta?',
    yourName: 'Seu nome',
    enterEmail: 'Digite seu email',
    enterPassword: 'Digite sua senha',
    enterName: 'Digite seu nome',
    required: 'Obrigatório',
    
    // Messages
    saveTemplates: 'Salve modelos para publicar turnos mais rápido',
    publishNewShift: 'Publique um novo turno para técnicos veterinários',
    
    // Placeholders
    comingSoon: 'Em Breve',
    featureComingSoon: 'Recurso Em Breve',
    phase2Feature: 'Este recurso será implementado na Fase 2+',
    placeholder: 'Marcador',
    
    // Errors
    errorOccurred: 'Ocorreu um erro',
    tryAgain: 'Tentar novamente',
    invalidCredentials: 'Credenciais inválidas',
    
    // Interest Form
    interestFormTitle: 'Registro de Interesse',
    interestFormSubtitle: 'Registre-se para receber um convite quando lançarmos',
    fullName: 'Nome Completo',
    enterFullName: 'Digite seu nome completo',
    phoneWhatsapp: 'Telefone ou WhatsApp',
    regionComuna: 'Região / Cidade',
    enterRegion: 'Digite sua região ou cidade',
    yourRole: 'Seu Papel',
    vetTechnician: 'Técnico Veterinário',
    vetTechnicianUncertified: 'Técnico Veterinário (não certificado)',
    vetClinic: 'Clínica Veterinária',
    veterinarian: 'Veterinário',
    petSitter: 'Pet Sitter / Cuidador',
    preferredLanguage: 'Idioma Preferido',
    optionalMessage: 'Mensagem Opcional',
    messagePlaceholder: 'Conte-nos sobre seu interesse...',
    wantLaunchInfo: 'Quero receber informações sobre o lançamento',
    submitInterest: 'Enviar Registro',
    thankYou: 'Obrigado!',
    willContact: 'Entraremos em contato quando lançarmos a plataforma',
    interestRegistration: 'Registro de Interesse',
    registerForInvitation: 'Registre-se para receber um convite',
    availableSoonChile: 'Disponível em breve no Chile',
    sdgStatement: 'Alinhado com os Objetivos de Desenvolvimento Sustentável das Nações Unidas (ODS 3, 8, 9 e 10)',
    platformInPreparation: 'A plataforma está em preparação. Registre-se para receber um convite.',
    registrationSoonAvailable: 'O registro estará disponível em breve para usuários no Chile.',
    
    // Footer
    copyright: '© 2025 LIBERADO. AI Powered Staffing Platform Empowering the Veterinary Industry.',
    termsOfService: 'Termos de Serviço',
    privacyPolicy: 'Política de Privacidade',
    contactSupport: 'Contatar Suporte',
    marketplacePolicy: 'Política do Mercado',
    
    // Phone Validation Error
    invalidPhoneError: 'Por favor, insira um número de telefone chileno válido (+56 9 #### #### ou 9#### ####)',
    
    // Thank You Page
    thankYouTitle: 'Obrigado!',
    thankYouMessage: 'Seu registro foi recebido. Entraremos em contato quando lançarmos a plataforma.',
    backToHome: 'Voltar ao Início',
    
    // Innovation & Roadmap
    innovationRoadmapTitle: 'Inovação & Roadmap',
    innovationRoadmapSubtitle: 'Nosso plano de desenvolvimento e visão de futuro',
    roadmapDisclaimer: 'Liberado está atualmente em fase de protótipo e validação. Nem todas as funcionalidades descritas estão implementadas neste momento.',
    
    // Current State (2025)
    roadmapCurrentTitle: 'Onde estamos hoje',
    roadmapCurrentPoint1: 'Protótipo funcional em fase inicial',
    roadmapCurrentPoint2: 'Pesquisa de mercado em andamento',
    roadmapCurrentPoint3: 'Exploração de parcerias com clínicas no Chile',
    
    // Implementation Phase (2026-2027)
    roadmapImplementationTitle: 'Próximos 12–24 meses (2026–2027)',
    roadmapImplementationPoint1: 'Implementação gradual pós-financiamento',
    roadmapImplementationPoint2: 'Automação + IA avançada',
    roadmapImplementationPoint3: 'Expansão nacional Chile',
    
    // AI Innovation Line
    roadmapAITitle: 'Linha do tempo IA',
    roadmapAIPoint1: 'Fase 1: Recomendação básica (atual)',
    roadmapAIPoint2: 'Fase 2: Matching preditivo',
    roadmapAIPoint3: 'Fase 3: Automação + suporte',
    roadmapAIPoint4: 'Fase futura: Módulo LENNY (extensão não clínica)',
    
    // Impact in Chile
    roadmapImpactTitle: 'Impacto esperado no Chile',
    roadmapImpactPoint1: 'Redução de carga operativa',
    roadmapImpactPoint2: 'Melhora na cobertura veterinária',
    roadmapImpactPoint3: 'Formalização laboral técnica',
    
    // SDG Alignment
    roadmapSDGTitle: 'Alinhamento com Objetivos de Desenvolvimento Sustentável (ODS)',
    roadmapSDGIntro: 'Liberado contribui diretamente para:',
    roadmapSDG1Title: 'ODS 8 – Trabalho decente e crescimento econômico',
    roadmapSDG1Text: 'Expande oportunidades de trabalho decente e flexível para técnicos veterinários, reduzindo o subemprego e fortalecendo clínicas.',
    roadmapSDG2Title: 'ODS 3 – Saúde e bem-estar',
    roadmapSDG2Text: 'Melhora a qualidade e continuidade do atendimento veterinário através da alocação eficiente de pessoal qualificado.',
    roadmapSDG3Title: 'ODS 9 – Indústria, inovação e infraestrutura',
    roadmapSDG3Text: 'Moderniza a infraestrutura de vinculação laboral em saúde veterinária através de ferramentas digitais e inteligência artificial.',
    roadmapSDG4Title: 'ODS 10 – Redução das desigualdades',
    roadmapSDG4Text: 'Amplia o acesso a oportunidades para técnicos em áreas rurais ou sub-representadas, diminuindo lacunas de emprego.',
    sdgFooterText: 'Projeto alinhado com os ODS 8, 3, 9 e 10 das Nações Unidas.',
    
    // Privacy Policy
    privacyPolicyTitle: 'Política de Privacidade',
    privacyLastUpdated: 'Última atualização',
    privacyLastUpdatedDate: 'Janeiro 2025',
    
    privacySection1Title: '1. Dados que coletamos',
    privacySection1Text: 'Na Liberado, coletamos as seguintes informações quando você se registra ou interage com nossa plataforma:',
    privacySection1Item1: 'Nome completo e endereço de e-mail',
    privacySection1Item2: 'Número de telefone ou WhatsApp',
    privacySection1Item3: 'Região ou cidade de residência',
    privacySection1Item4: 'Papel profissional (técnico, clínica, veterinário, etc.)',
    
    privacySection2Title: '2. Uso da informação',
    privacySection2Text: 'Utilizamos seus dados para os seguintes propósitos:',
    privacySection2Item1: 'Comunicar-nos com você sobre o lançamento da plataforma',
    privacySection2Item2: 'Personalizar sua experiência no Liberado',
    privacySection2Item3: 'Melhorar nossos serviços e funcionalidades',
    privacySection2Item4: 'Cumprir com requisitos legais e regulatórios',
    
    privacySection3Title: '3. Armazenamento de dados',
    privacySection3Text: 'Os dados podem ser armazenados no Chile e/ou nos Estados Unidos, utilizando serviços de hospedagem seguros e certificados. Implementamos medidas técnicas e organizacionais para proteger suas informações.',
    
    privacySection4Title: '4. Segurança',
    privacySection4Text: 'Aplicamos padrões de segurança da indústria para proteger seus dados pessoais contra acesso não autorizado, alteração, divulgação ou destruição. No entanto, nenhum sistema é 100% seguro, por isso recomendamos tomar precauções adicionais.',
    
    privacySection5Title: '5. Seus direitos',
    privacySection5Text: 'Como usuário, você tem o direito de:',
    privacySection5Item1: 'Acessar seus dados pessoais',
    privacySection5Item2: 'Solicitar a correção ou eliminação de suas informações',
    privacySection5Item3: 'Opor-se ao processamento de seus dados',
    privacySection5Item4: 'Retirar seu consentimento a qualquer momento',
    
    privacyContactTitle: 'Contato para consultas de privacidade',
    privacyContactText: 'Se você tiver perguntas sobre esta política, entre em contato conosco em',
  },
};

export const getTranslation = (lang, key) => {
  return translations[lang]?.[key] || translations['es'][key] || key;
};

// Translation coverage report
export const getTranslationCoverage = () => {
  const languages = ['es', 'en', 'pt'];
  const report = {};
  
  const esKeys = Object.keys(translations.es);
  
  languages.forEach(lang => {
    const langKeys = Object.keys(translations[lang]);
    const missing = esKeys.filter(key => !translations[lang][key]);
    
    report[lang] = {
      total: esKeys.length,
      translated: langKeys.length,
      missing: missing,
      coverage: ((langKeys.length / esKeys.length) * 100).toFixed(2) + '%'
    };
  });
  
  return report;
};
